// Single source of truth lives in checklistItemInputOptions; imported here (and re-exported
// under the runtime name) so existing imports keep working without duplicating the map.
import {
  DECISION_TYPE_STYLES as flagPurposeTypeStyles,
  PURPOSE_TYPE_LABELS,
} from '@/dsm-components/checklist-templates/checklistItemInputOptions';
import type { RequirementFlagSettingOption } from '@/services/queues';
import type React from 'react';
import { useCallback } from 'react';

import { FlagPurposeType } from 'types';

export { flagPurposeTypeStyles, PURPOSE_TYPE_LABELS };

export const PURPOSE_TYPES = Object.values(FlagPurposeType);

export const WHITE_STYLE_CONST = { color: 'var(--text-on-inverted-primary)' } as const;

interface SearchResultItemProps {
  setting: RequirementFlagSettingOption;
  onSelect: (setting: RequirementFlagSettingOption) => void;
}

export const SearchResultItem: React.FC<SearchResultItemProps> = ({ setting, onSelect }) => {
  const handleClick = useCallback(() => onSelect(setting), [onSelect, setting]);
  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex w-full flex-col gap-[2px] px-[16px] py-[10px] text-left hover:bg-[var(--canvas-subtle)]"
    >
      <span className="text-[14px] font-bold text-text-primary">{setting.name}</span>
    </button>
  );
};

interface PurposeTypeButtonProps {
  purposeType: FlagPurposeType;
  isSelected: boolean;
  onSelect: (purposeType: FlagPurposeType) => void;
}

export const PurposeTypeButton: React.FC<PurposeTypeButtonProps> = ({ purposeType, isSelected, onSelect }) => {
  const handleClick = useCallback(() => onSelect(purposeType), [onSelect, purposeType]);
  const bg = flagPurposeTypeStyles[purposeType];
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`rounded-[10px] px-[14px] py-[8px] text-[12px] font-bold transition-opacity ${bg} ${isSelected ? 'opacity-100 ring-2 ring-[var(--text-on-inverted-primary)] ring-offset-1' : 'opacity-50 hover:opacity-75'}`}
    >
      <span>{PURPOSE_TYPE_LABELS[purposeType]}</span>
    </button>
  );
};
